import { Icon, Loader } from '@/shared'
import blanckPhoto from '@App/assets/images/nullDoctorImage.png'
import { EIcons } from '@App/types/iconType'

import { SectionTitle } from '../SectionTitle/SectionTitle'

import { ImageLoader } from './ImageLoader/ImageLoader'
import style from './PhotoEditor.module.scss'

interface IProps {
    photo: string | null
    isFetching: boolean
    onUploadImageCallback: (file: File) => void
    isOpen: boolean
    onSetIsOpen: (isOpen: boolean) => void
    onRemoveImageCallback: () => void
}

export const PhotoEditor = (props: IProps) => {
    const { photo, isFetching, onUploadImageCallback, isOpen, onSetIsOpen, onRemoveImageCallback } = props

    return (
        <div className={style.container}>
            <ImageLoader
                show={isOpen}
                onClose={() => onSetIsOpen(false)}
                onUploadImageCallback={onUploadImageCallback}
                allowedFormats={['jpg', 'jpeg', 'png']}
                currentImage={photo || blanckPhoto}
            />
            <SectionTitle
                header='Фото'
                description='Загрузите фотографию сотрудника, по возможности старайтесь не оставлять карточку без фотографии на долгое время'
            />
            <div className={style.photo}>
                {isFetching && <Loader />}
                {!isFetching && (
                    <>
                        <div className={style.imgWrapper}>
                            <img
                                src={photo || blanckPhoto}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null
                                    currentTarget.src =
                                        'https://www.meme-arsenal.com/memes/20d600dd79c74b47a39ec029235fa3a1.jpg'
                                }}
                                alt='Изображение не работает'
                            />
                        </div>
                        <div className={style.btnsWrapper}>
                            <div onClick={() => onSetIsOpen(true)}>
                                <Icon iconName={EIcons.PDVCE} />
                            </div>
                            <div onClick={onRemoveImageCallback}>
                                <Icon iconName={EIcons.TRSH} />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
